/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CountryRegionApiDto } from './country-region.model';

export interface ResidenceCountryApiDto {
  code?: string;
  name?: string;
  currency?: string;
  countryRegionType?: ResidenceCountryApiDto.CountryRegionTypeEnum;
  regions?: Array<CountryRegionApiDto>;
  /**
   * Custom element weigh. This property is used to define a custom sort order of this element.
   */
  weight?: number;
  phoneCode?: string;
}
export namespace ResidenceCountryApiDto {
  export const CountryRegionTypeEnum = {
    CITY: 'CITY',
    STATE: 'STATE',
    POSTALCODE: 'POSTALCODE',
  } as const;
  export type CountryRegionTypeEnum = (typeof CountryRegionTypeEnum)[keyof typeof CountryRegionTypeEnum];
}
